import NotificationTab from './NotificationTab'

export default NotificationTab
